/*
 * Copyright (c) 2024. Tooling Team
 */

import React from "react";
import { MintHeader } from "../navigation/MintHeader";

export const Forbidden = () => (
  <div>
    <MintHeader globalNav={false}></MintHeader>
    <div className="logged-out">
      <h1>403 Forbidden</h1>
      <p>You do not have permission to access this page or resource.</p>
    </div>
  </div>
);
